<template>
    <div>
        <top></top>
        <div class="container ods_wp">
            <breadcrumb></breadcrumb>

            <div class="my-title">
                订单详情
            </div>
            <div class="step">
                <el-steps
                    :active="active"
                    align-center
                    process-status="wait"
                >
                    <el-step title="提交订单"></el-step>
                    <el-step title="确认付款"></el-step>
                    <el-step title="商品发货"></el-step>
                    <el-step title="交易完成"></el-step>
                </el-steps>
            </div>
            <div class="goods">
                <div
                    class="goods-item F-flex"
                    v-for="(item, index) in detail.item"
                    :key="index"
                >
                    <div class="flex ali-cen" @click="onDetailOrder(item.goods_id)">
                        <img
                            :src="item.goods_image"
                            alt=""
                            style="width: 106px;height: 100px;margin-right: 10px;"
                        />
                        <div class="goods-item-con">
                            <div class="f16">{{ item.goods_title }}</div>
                            <div class="f12">{{ item.goods_sku_text }}</div>
                            <div class="f12">
                                <span class="grey">当前订单状态：</span
                                ><span class="orange">{{
                                    detail.status_name
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div v-for="(btn, index) in item.btns" :key="index">
                            <div
                                class="btn"
                                v-if="btn === 'get'"
                                @click="
                                    onConfirm({
                                        orderId: detail.id,
                                        orderItemId: item.id,
                                        btn: btn
                                    })
                                "
                            >
                                确认收货
                            </div>
                            <div
                                class="btn"
                                v-if="btn === 'buy_again'"
                                @click="onPay(item.goods_id)"
                            >
                                再次购买
                            </div>
                            <div
                                class="btn"
                                v-if="btn === 'comment'"
                                @click="
                                    evaluatebtn({
                                        orderId: detail.id,
                                        orderItemId: item.id,
                                        btn: btn
                                    })
                                "
                            >
                                去评价
                            </div>
                            <div
                                class="btn"
                                style="color: #999999;"
                                @click="
                                    onAftersale({
                                        orderId: detail.id,
                                        orderItemId: item.id,
                                        btn: btn
                                    })
                                "
                                v-if="btn === 'aftersale'"
                            >
                                申请售后
                            </div>
                            <div
                                class="btn"
                                style="color: #999999;"
                                @click="
                                    onAftersale({
                                        orderId: detail.id,
                                        orderItemId: item.id,
                                        btn: btn
                                    })
                                "
                                v-if="btn === 're_aftersale'"
                            >
                                重新售后
                            </div>
                            <div
                                class="btn"
                                style="color: #999999;"
                                @click="
                                    onAftersale({
                                        orderId: detail.id,
                                        orderItemId: item.id,
                                        aftersaleId: item.ext_arr.aftersale_id,
                                        btn: btn
                                    })
                                "
                                v-if="btn === 'aftersale_info'"
                            >
                                售后详情
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order_d">
                    <div v-for="btn in detail.btns" :key="btn">
                        <div
                            class="btn"
                            v-if="btn === 'cancel'"
                            @click="onCenelOrder(detail.id)"
                        >
                            取消订单
                        </div>
                        <div
                            class="btn"
                            v-if="btn === 'pay'"
                            @click="onPayOrder(detail.id)"
                        >
                            付款
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex jus-between">
                <div class="info ">
                    <div class="f18">订单信息</div>
                    <!-- <div class="">订单信息: XXX</div> -->
                    <div class="">
                        收货地址：{{ detail.province_name }}{{ detail.city_name
                        }}{{ detail.area_name }}{{ detail.address }}
                    </div>
                    <div class="">联系方式：{{ detail.phone }}</div>
                    <div class="">买家留言：{{detail.remark}}</div>
                    <!-- <div class="">发票信息：</div> -->
                    <div class="">订单号：{{ detail.order_sn }}</div>
                    <div class="">支付方式：{{ payType[detail.pay_type] }}</div>
                    <div class="">运费：￥{{ detail.dispatch_amount }}</div>
                    <div class="">优惠金额：￥{{ detail.discount_fee }}</div>
                    <div class="">实付金额：￥{{ detail.total_fee }}</div>

                </div>
                <div class="wuliu">
                    <div style="margin-bottom: 20px;">订单跟踪</div>
                    <div v-if="exrpessLog.length === 0" class="text-center">
                        暂无物流信息~
                    </div>
                    <div class="wuliu_detail" v-if="exrpessLog.length > 0">
                        <el-timeline :reverse="reverse">
                            <el-timeline-item
                                v-for="(activity, index) in expressList"
                                :key="index"
                                :timestamp='activity.changedate'
                            >

                                {{ activity.content }}
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import {
    orderDetail,
    expressIndex,
    orderConfirm,
    orderCanel
} from "@/api/index.js";
import { timestampToTime } from "@/util/util.js";
import top from "@/components/top.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import bottom from "@/components/bottom.vue";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        // (active == 1 ? active + 2 : active + 1)==3?active+2:active+1
        return {
            active: 1,
            detail: {},
            payType: {
                wallet: "余额支付",
                wechat: "微信支付",
                alipay: "支付宝支付",
                iospay: "ApplePay"
            },
            expressDetail: {},
            exrpessLog: [],
            firstGoods: {},
            expressList: [],
            reverse:true,
            status_code:'',

        };
    },
    props: {
        value: {
            type: Object,
            default: {}
        }
    },
    watch: {
        value: {
            handler(newValue) {
                console.log(newValue, "new");
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.getOrderDetail();
    },
    methods: {
        //订单详情
        getOrderDetail() {
            let that = this;
            let id = this.$route.query.orderId;

            orderDetail({ id: id }, header).then(res => {
                if (res.code === 1) {
                    that.detail = res.data;
                    console.log(that.detail);
                    this.status_code = that.detail.status_code
                    //console.log(this.status_code); "nopay" "nosend" "noget" "finish"
                    if(this.status_code == "nopay"){
                        this.active = 1
                    }else if(this.status_code == "nosend"){
                        this.active = 2
                    }else if(this.status_code == "noget"){
                        this.active = 3
                    }else{
                         this.active = 4
                    }
                    this.getExpressDetail();
                }
            });
        },
        //物流信息
        getExpressDetail() {
            let that = this;
            let id = this.$route.query.orderId;
            console.log(id);
            expressIndex({ order_id: id }, header).then(res => {
                if (res.code === 1) {
                    console.log(res);
                    this.expressList = res.data[0].log
                    that.expressDetail = res.data;
                    if (res.data.length == 0) {
                        return;
                    }
                    // res.data[0].log.forEach(i=>{
                    //   i.time = timestampToTime(i.createtime * 1000);
                    // })
                    that.exrpessLog = res.data[0].log;
                    // console.log(that.exrpessLog);
                }
            });
        },
        onAftersale(e) {
            // this.$emit("checkView", {
            //     menuId: 17,
            //     data: e
            // });
            console.log(e);
            let data = JSON.stringify(e);
            console.log(data);
            this.$router.push({ path: "/refu", query: { value: data } });
        },
        evaluatebtn(e) {
            let data = JSON.stringify(e);
            console.log(data);
            this.$router.push({ path: "/evl", query: { value: data } });
        },
        onConfirm(e) {

            orderConfirm(
                { id: e.orderId, order_item_id: e.orderItemId },
                header
            ).then(res => {
                if (res.code === 1) {
                    this.getOrderDetail();

                }
            });
        },
        //再次购买
        onPay(id) {
            console.log(id);
            // this.$router.push({name:'info'})
            this.$router.push({
                name: "info",
                query: {
                    id: id
                }
            });
        },
        //取消订单
        onCenelOrder(id) {
            orderCanel({ id: id }, header).then(res => {
                if (res.code !== 1) {
                    return;
                }
                this.$router.go(0);
            });
        },
        //支付
        onPayOrder(id) {
            this.$router.push({ name: "pay", query: { id: id } });
        },
        //点击进入详情
        onDetailOrder(id) {
            console.log(id);
            this.$router.push({ path: "/info", query: { id: id } });
        }
    },
    components: {
        top,
        breadcrumb,
        bottom
    }
};
</script>
<style lang="less">
.wuliu_detail{
    margin-top: 50px;
}
.ods_wp {
    background-color: #fff;
    padding: 30px;
    margin-top: 20px;
    // height: 1000px;
}
.step {
    width: 70%;
    margin: 20px 0;
    margin-left: -50px;
}
.goods {
    padding: 20px;
    background: #f5f5f5;
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .goods-item {
        .goods-item-con {
            div {
                line-height: 30px;
            }
        }
    }
}
.info {
    font-size: 14px;
    padding: 20px;
    background-color: #f6f6f6;
    width: 40%;
    height: 350px;

    div {
        line-height: 30px;
    }
}
.wuliu {
    width: 45%;
}
.btn {
    width: 98px;
    height: 37px;
    background: #ffffff;
    border-radius: 5px;
    color: #ff6701;
    border: 1px solid;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    margin-bottom: 5px;
    cursor: pointer;
}
.order_d {
  position: absolute;
    top: 0;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    padding-right: 20px;
}
.el-timeline-item__wrapper{
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/ods.vue